import { TOP_UPS, formatPrice } from '../../../config/billingConfig';
import { ShoppingCart, Zap } from 'lucide-react';

interface TopUpCardsProps {
  onSelectTopUp: (priceId: string) => void;
  isLoading: boolean;
}

export function TopUpCards({ onSelectTopUp, isLoading }: TopUpCardsProps) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '16px',
      }}
    >
      {TOP_UPS.map((topUp) => {
        const pricePerCredit = (topUp.price / topUp.credits / 100).toFixed(3);

        return (
              <div
            key={topUp.id}
            style={{
              background: 'var(--admin-card-bg)',
              border: '1px solid var(--admin-card-border)',
              borderRadius: '0',
              padding: '20px',
              display: 'flex',
              flexDirection: 'column',
              gap: '14px',
              transition: 'border-color 0.2s, transform 0.2s',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p
                  style={{
                    fontFamily: "'Space Grotesk', sans-serif",
                    fontWeight: 700,
                    fontSize: '15px',
                    color: 'var(--admin-card-text)',
                    margin: 0,
                  }}
                >
                  {topUp.label}
                </p>
                <p style={{ fontFamily: "'Inter', sans-serif", fontSize: '11px', color: 'var(--admin-card-subtext)', margin: '2px 0 0' }}>
                  ${pricePerCredit} / credit
                </p>
              </div>
              <div
                style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '0',
                  background: 'rgba(56,189,248,0.08)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Zap size={16} color="var(--color-status-sky, #38bdf8)" />
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
              <span
                style={{
                  fontSize: '26px',
                  fontWeight: 800,
                  color: 'var(--admin-card-text)',
                  fontFamily: "'Space Grotesk', sans-serif",
                }}
              >
                {topUp.credits.toLocaleString()}
              </span>
              <span style={{ fontFamily: "'Inter', sans-serif", fontSize: '13px', color: 'var(--admin-card-subtext)' }}>credits</span>
            </div>

            <button
              onClick={() => onSelectTopUp(topUp.stripePriceId)}
              disabled={isLoading || !topUp.stripePriceId}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                padding: '9px',
                borderRadius: '0',
                border: 'none',
                cursor: isLoading ? 'not-allowed' : 'pointer',
                fontWeight: 700,
                fontSize: '13px',
                fontFamily: "'Inter', sans-serif",
                background: '#ffffff',
                color: '#000000',
                transition: 'opacity 0.2s',
                opacity: isLoading ? 0.7 : 1,
              }}
            >
              <ShoppingCart size={14} />
              {formatPrice(topUp.price)}
            </button>
          </div>
        );
      })}
    </div>
  );
}
